import React, { FunctionComponent } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { forgotPasswordEmail } from '../../../../../app/auth/auth.actions';

import { useRequiredValidation } from '../../../../../utils/form/validation.utils';

import { FormTextInput } from '../../inputs/TextInput';

export const ForgotPasswordMailForm: FunctionComponent = () => {
  const dispatch = useDispatch();

  const formProps = useForm();

  const requiredValidation = useRequiredValidation();

  const onSubmit = (data: { email: string }) => {
    dispatch(forgotPasswordEmail(data.email));
  };

  return (
    <FormProvider {...formProps}>
      <form
        id="forgotPasswordMail-form"
        className="topic-form"
        onSubmit={formProps.handleSubmit((formData) => onSubmit(formData as { email: string }))}
        method="post"
      >
        <div className="field-container">
          <FormTextInput
            id="email"
            name="email"
            type="email"
            label="Please enter your email to recover your password"
            placeholder="Email"
            validation={requiredValidation}
          />
        </div>
      </form>
    </FormProvider>
  );
};
